import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Box, Button, Icon } from '@node-space/ui-components'
import { PathNames } from 'constants/General'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { useWalletContext } from 'hooks/context/useWalletContext'
import { useMappedRoles } from 'hooks/useMappedRoles'
import { WalletSheet } from 'pages/Wallets/components/Sheet/WalletSheet'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { ActionIds } from 'types/types'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import track from 'utils/tracker'

interface ChannelsHeaderButtonsProps {
  refetchChannels?: () => void
  showManageChannels?: boolean
  secondaryAction?: boolean
  createButtonCopy?: string
}

export const ChannelsHeaderButtons = ({
  refetchChannels,
  showManageChannels = true,
  secondaryAction = false,
  createButtonCopy,
}: ChannelsHeaderButtonsProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { viewOnly } = useProfileContext()
  const wallet = useWalletContext()
  const permissions = useMappedRoles()?.channels
  const isEditDisabled = !permissions?.canEdit
  const [, setWalletAction] = useContext(WalletActionContext)
  const [isSheetOpen, setIsSheetOpen] = useState(false)

  const handleOpenChannelPaymentSheet = () => {
    setWalletAction({
      actionId: ActionIds?.CHANNEL_PAYMENT,
      header: t('payments.channelPayments.contactStepHeader'),
      onClose: () => {
        setIsSheetOpen(false)
      },
      meta: {
        sourceWallet: wallet,
        onPaymentChannelSuccess: refetchChannels,
      },
    })
    setIsSheetOpen(true)
  }

  return (
    <>
      <Box flex gap={12}>
        {!isEditDisabled && (
          <Button
            disabled={viewOnly}
            {...(secondaryAction && { variant: 'secondary' })}
            onClick={() => {
              handleOpenChannelPaymentSheet()

              track.Amp.track(AmplitudeEvent.CHANNEL_INITIATE, {
                category: AmplitudeEventCategory.MERCHANT_PORTAL,
                action: AmplitudeEventAction.CLICK,
              })
            }}
            iconElement={<Icon name="Plus" />}
          >
            {createButtonCopy || t('payments.channels.createChannel')}
          </Button>
        )}
        {showManageChannels && (
          <Button
            variant="secondary"
            onClick={() => void navigate(`${PathNames.SETTINGS}${PathNames.MANAGE_CHANNELS}`)}
            iconElement={<Icon name="SimplePencilCustom" />}
          >
            {`${t('payments.channels.manageChannels')}`}
          </Button>
        )}
      </Box>

      <WalletSheet isSheetOpen={isSheetOpen} />
    </>
  )
}
